import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-43ae162a")

_pushScopeId("data-v-43ae162a")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" MPE智慧健康数字化睡眠管理系统 ")
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"font-size":".95rem","margin-left":"8px","margin-bottom":"-3px"} }
const _hoisted_6 = { class: "page-body" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "charts-content" }
const _hoisted_9 = { class: "d-flex full" }
const _hoisted_10 = { class: "data-content" }
const _hoisted_11 = { class: "count-detail" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "title" }, "APP用户总数"),
  /*#__PURE__*/_createVNode("p", { class: "value" }, "205682")
], -1)
const _hoisted_13 = { class: "map-content" }
const _hoisted_14 = {
  class: "flex-1",
  style: {"position":"relative"}
}
const _hoisted_15 = {
  class: "d-flex",
  style: {"padding-bottom":"5vh"}
}
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "iframe" }
const _hoisted_19 = /*#__PURE__*/_createVNode("iframe", {
  src: `/#/gravity/realtime`,
  style: {"height":"33%"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")
  const _component_active_detail = _resolveComponent("active-detail")
  const _component_table_div = _resolveComponent("table-div")
  const _component_china = _resolveComponent("china")
  const _component_quality = _resolveComponent("quality")
  const _component_long = _resolveComponent("long")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString($setup.day) + " ", 1 /* TEXT */),
        _createVNode("span", _hoisted_5, _toDisplayString($setup.time), 1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_my_card, null, {
                  default: _withId(() => [
                    _createVNode(_component_my_card_body, { class: "pa-4" }, {
                      default: _withId(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_active_detail),
              _createVNode(_component_table_div, {
                style: {"height":"20%"},
                title: "设备列表",
                thead: ['设备号', '用户名'],
                list: $setup.deviceList
              }, null, 8, ["list"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_china)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_quality)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_long)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("iframe", {
          src: `/#/realtime?${$setup.query}`,
          style: {"height":"67%"}
        }, null, 8, ["src"])
      ])
    ])
  ]))
})